import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'

import Review from './Review'

import { resetClaims, getDateTimeDisplay } from '../actions'
import { submitReview } from './actions'

const mapDispatchToProps = {
  submitReview,
  resetClaims,
}

const mapStateToProps = state => {
  const { ...rest } = state.claimLocation.claimLocation || {}

  return {
    vehicle: state.vehicles.vehicle,
    geoLocation: rest,
    weather: state.weather.description,
    time: state.dateAndTime.time,
    date: state.dateAndTime.date,
    dateTimeDisplay: getDateTimeDisplay(state.dateAndTime.date, state.dateAndTime.time),
    timeAndDateCompleted: state.dateAndTime.stepCompleted,
    driver: state.drivers.driver,
    driversLicenseFile: state.drivers.driversLicenseFile,
    damage: state.whatHappened,
    pictures: state.pictures.pictures,
    vehicleAndDriver: state.vehicleAndDriver.vehicleAndDriver,
    otherDriversLicenseFile: state.vehicleAndDriver.otherDriversLicenseFile,
    officer: state.investigatingOfficer.officer,
    passenger: state.passenger.passenger,
    witness: state.witness.witness,
    note: state.note.note,
    submitting: state.reviewReducer.submitting,
    successful: state.reviewReducer.successful,
    labels: getFromSettings(state, 'labels', {}),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Review)
